export const CART_UPDATE_CART = 'CART_UPDATE_CART';
export const CART_UPDATE_COUNT = 'CART_UPDATE_COUNT';
export const CART_UPDATE_LOADING = 'CART_UPDATE_LOADING';
export const CART_REMOVE_CART = 'CART_REMOVE_CART';
